import type { ReactNode } from "react";
import { useSession } from "../services/auth0/session";
import { Navigate, useLocation } from "react-router";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: string[];
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, isLoggedIn, hasRole } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex flex-1 h-screen justify-center items-center">
        <Loader2 className="w-10 h-10 animate-spin" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/" state={{ returnTo: location.pathname }} replace />;
  }

  if (!hasRole("ADMIN")) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
